import Mock from 'mockjs'
export default {
	/* 
		用户登陆验证
		@param name, addr, age, birth, sex
		@return {{code: number, data: {message: string}}}
	*/
	loginUser: config => {
		const { username, password } = JSON.parse(config.body);
		//console.log(username, "<- username");
		//console.log(password, "<- password");
		if(username==='user' && password ==='password')
		{
			const tokenForCurUser = Mock.Random.guid();
			return {
				code: 20000,
				data: {
					token: tokenForCurUser,
					username: username,
					password: Mock.Random.guid(),
					message: '登陆成功',
					menu: [
						/*
						{
							path: '/userinfo',
							name: 'userinfo',
							label: '用户 ' + username.toUpperCase() +'',
							icon: 'user',
							url: 'UserInfo.vue',
							top: true,
						},*/
						{
							path: '/Index',
							name: 'Index',
							label: '首页',
							icon: 's-home',
							url: 'Index.vue',
							meta: { title: "运营中心 - 首页", label: '首页', },
							top: 1,
						},
						{
							path: '/m01',
							name: 'm01',
							label: 'M01菜单',
							icon: 'video-play',
							url: 'M01.vue',
							meta: { label: 'M01菜单', },
						},
						{
							path: '/m02',
							name: 'm02',
							label: 'M02菜单',
							icon: 'video-play',
							url: 'M02.vue',
							meta: { label: 'M02菜单', },
						},
					],
				}
			}
		}
		else if(username==='admin' && password ==='password')
		{
			const tokenForCurUser = Mock.Random.guid();
			return {
				code: 20000,
				data: {
					token: tokenForCurUser,
					username: username,
					password: Mock.Random.guid(),
					message: '登陆成功',
					menu: [
						/*
						{
							path: '/userinfo',
							name: 'userinfo',
							label: '管理员 ' + username.toUpperCase() +'',
							icon: 'user-solid',
							url: 'UserInfo.vue',
							top: true,
						},*/
						{
							path: '/Index',
							name: 'Index',
							label: '首页',
							icon: 's-home',
							url: 'Index.vue',
							meta: { title: "运营中心 - 首页", label: '首页', },
							top: 1,
						},
						{
							path: '/user',
							name: 'user',
							label: '用户管理',
							icon: 'user',
							url: 'User.vue',
							meta: { title: "运营中心 - 用户管理", label: '用户管理', },
						},
						{
							path: '/m01',
							name: 'm01',
							label: 'M01菜单',
							icon: 'video-play',
							url: 'M01.vue',
							meta: { label: 'M01菜单', },
						},
						{
							path: '/m02',
							name: 'm02',
							label: 'M02菜单',
							icon: 'video-play',
							url: 'M02.vue',
							meta: { label: 'M02菜单', },
						},
						{
							label: '02LL',
							icon: 'location',
							name: '02ll',
							url: 'Main.vue',
							children: [
								{
									path: '/user',
									name: 'user',
									label: '用户管理',
									icon: 'user',
									url: 'User.vue',
									meta: { title: "运营中心 - 用户管理", label: '用户管理', },
								},
								{
									path: '/m01',
									name: 'm01',
									label: 'M01菜单',
									icon: 'video-play',
									url: 'M01.vue',
									meta: { label: 'M01菜单', },
								},
								{
									path: '/m02',
									name: 'm02',
									label: 'M02菜单',
									icon: 'video-play',
									url: 'M02.vue',
									meta: { label: 'M02菜单', },
								},
							],
						},
					],
				}
			}
		}
		else
		{
			return {
				code: -1,
				data: {
					message: '登陆失败',
				}
			}
		}
	},
}